import MUIDataTable from "mui-datatables";
import styled from "@emotion/styled";

const MUITable = styled(MUIDataTable)(({ theme }) => ({
  backgroundColor: "#ffff",
  //border: "none",
  boxShadow:
    "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
  ".MuiTable-root": {
    ".MuiTableCell-root": {
      "&:nth-of-type(1)": {
        paddingTop: "0",
        paddingBottom: "0",
      },
    },
  },

  "& .MuiTableCell-head": {
    "& span": {
      "& .MuiButton-root": {
        textTransform: "none",
        marginLeft: "-8px",
        minWidth: 0,
        marginRight: "8px",
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
  },
  "& .MuiTableCell-root": {
    //backgroundColor: "#f5f5f5",
    paddingTop: "5px",
    paddingBottom: "5px",
    fontSize: "0.75rem",
    "& .MuiChip-root": {
      height: "25px",
      fontSize: "0.75rem",
    },
  },

  "& .MuiTypography-root": {
    fontSize: "1.5rem",
    color: "#666666",
    marginBottom: "1rem",
    fontWeight: 600,
    margin: 0,
    lineHeight: 1.334,
    letterSpacing: "0em",
    paddingTop: "32px",
  },
  "& .MuiTable-responsiveScroll": {
    maxHeight: "none",
  },
}));

export default MUITable;
